<forge-card class="chart" no-padding>
    <forge-toolbar attr.slot="header">
        <div slot="start" fxLayout="column">
            <h2 class="forge-typography--heading4">{{ChartTitle}}</h2>
            <div *ngIf="isLoaded && !errorMessage" fxLayout="row" fxLayoutAlign="start center">
                <span class="forge-typography--subheading1">{{ProjectLabel}}</span>
            </div>
        </div>

        <forge-icon-button slot="end" class="chart-settings" (click)="openSettings()" tabindex="0"
                            aria-haspopup="true" telemetry="Chart settings" aria-label="chart settings">
            <forge-tooltip>Chart settings</forge-tooltip>
            <forge-icon name="settings"></forge-icon>
        </forge-icon-button>
    </forge-toolbar>

    <div class="metadata-padding">
        <busy-indicator *ngIf="!isLoaded" chart="true"></busy-indicator>
        <account-detail-card *ngIf="isLoaded && chartHasData" fxFlex="auto" [chartHasData]="chartHasData" [shareable]="true" [totals]="chartData" index="2">
        </account-detail-card>

        <div *ngIf="!chartHasData">
            Not enough data to display breakdown
        </div>

        <div *ngIf="errorMessage" class="error-red">{{errorMessage}}</div>
    </div>
</forge-card>